import { connect } from 'react-redux'
import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import { createSelector } from 'reselect'
import CreateTrip from 'src/components/riders/rider-portal/trips/create/CreateTrip'
import { getCurrentUserInfo } from 'src/state/actions/rider-portal'
import {
  createTripBooking,
  getAvailableProducts,
  getRiderSavedLocations,
  getServicesByCurrentLocation,
  getServiceDesignatedZones,
  getServiceZones
} from 'src/state/actions/rider-portal/main'
import { IStoreState } from 'src/types'
import { IAvailableProductsPayload, ICreateTripBooking } from 'src/types/rider-portal'

// Memoized selectors
const selectRiderPortal = (state: IStoreState) => state.riderPortal

const selectAvailableProducts = createSelector(
  selectRiderPortal,
  riderPortal => riderPortal.availableProducts
)

const selectAvailableServices = createSelector(
  selectRiderPortal,
  riderPortal => riderPortal.availableServices
)

const selectDesignatedServiceZones = createSelector(
  selectRiderPortal,
  riderPortal => riderPortal.designatedServiceZones
)

const selectServiceZones = createSelector(
  selectRiderPortal,
  riderPortal => riderPortal.serviceZones
)

const selectSavedLocations = createSelector(
  selectRiderPortal,
  riderPortal => riderPortal.savedLocations
)

const selectLoading = createSelector(
  selectRiderPortal,
  riderPortal => riderPortal.loading
)

const selectLoggedInRiderDetails = createSelector(
  selectRiderPortal,
  riderPortal => riderPortal.loggedInRiderDetails
)

export function mapStateToProps(state: IStoreState, ownProps: Record<string, unknown>): Record<string, unknown> {
  const availableProducts = selectAvailableProducts(state)
  const availableServices = selectAvailableServices(state)
  const designatedServiceZones = selectDesignatedServiceZones(state)
  const serviceZones = selectServiceZones(state)
  const savedLocations = selectSavedLocations(state)
  const loading = selectLoading(state)
  const loggedInRiderDetails = selectLoggedInRiderDetails(state)

  const { fetchingProducts, fetchingSavedLocations, fetchingServices, isLoading, requestingTripBooking } = loading

  return {
    availableProducts,
    availableServices,
    designatedServiceZones,
    fetchingProducts,
    fetchingSavedLocations,
    fetchingServices,
    isLoading,
    loggedInRiderDetails,
    requestingTripBooking,
    riderSavedLocations: savedLocations,
    serviceZones
  }
}

export function mapDispatchToProps(dispatch: ThunkDispatch<IStoreState, unknown, AnyAction>): Record<string, unknown> {
  return {
    createTripBooking: (payload: ICreateTripBooking) => dispatch(createTripBooking(payload)),
    getAvailableProducts: (payload: IAvailableProductsPayload, riderId: string) =>
      dispatch(getAvailableProducts(payload, riderId)),
    getCurrentUserInfo: (userId: string) => {
      if (userId) {
        dispatch(getCurrentUserInfo(userId))
      }
    },
    getRiderSavedLocations: (id: string) => dispatch(getRiderSavedLocations(id)),
    getServicesByCurrentLocation: (currentLocation: google.maps.LatLngLiteral, orgId: string, type: string) =>
      dispatch(getServicesByCurrentLocation(currentLocation, orgId, type)),
    getServiceZones: (organizationId: string, serviceId: string) =>
      dispatch(getServiceZones(organizationId, serviceId)),
    getServiceDesignatedZones: (serviceId: string) => dispatch(getServiceDesignatedZones(serviceId))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateTrip)



// WEBPACK FOOTER //
// ./src/containers/riders/rider-portal/trips/create/CreateTrip.ts